// @ts-nocheck
import _ from 'lodash';
import * as sagaActions from './sagaActions';
import { put, takeLatest, select } from 'redux-saga/effects';
import * as slice from './reducer';
import { v4 as uuidv4 } from 'uuid';
import { getQueries } from './selectors';
import { updateGrid } from 'models/dynamicGrid/sagaActions';
import { getGridFilters } from 'models/dynamicGrid/selector';
import * as dynamicGridSlice from 'models/dynamicGrid/reducer';
import { getDispatch, getState } from 'reducers';

export default function* rootSaga() {
	function* createUpdateSearchQuery({ payload }: any) {
		const { id, selectedCriteria, searchInput, searchInputEnd, tableId, selectedOperator, isUpdate } = payload;
		let searchQueries = yield select((state) => getQueries(state, payload.tableId));
		searchQueries = searchQueries || [];
		if (id && searchQueries.length) {
			searchQueries = _.map(searchQueries, (q) => {
				if (q.id === id) {
					return {
						id,
						criteria: selectedCriteria,
						query:
							selectedOperator && (selectedOperator.value === 'btw' || selectedOperator.value === 'nbtw')
								? { from: searchInput, to: searchInputEnd }
								: searchInput,
						operator: selectedOperator,
					};
				}
				return q;
			});
		} else {
			searchQueries = [
				...searchQueries,
				{
					id: id || uuidv4(),
					criteria: selectedCriteria,
					query:
						selectedOperator && (selectedOperator.value === 'btw' || selectedOperator.value === 'nbtw')
							? { from: searchInput, to: searchInputEnd }
							: searchInput,
					operator: selectedOperator,
				},
			];
		}

		yield put(slice.updateSearchQueries({ searchQueries, tableId }));
		yield reloadGrid(tableId, searchQueries);
	}

	function reloadGrid(tableId, search, isStorageEnabled = true) {
		const dispatch = getDispatch();
		let filters = getGridFilters(getState(), tableId);

		let index =
			filters &&
			filters.search &&
			_.findIndex(filters.search, function (singleCreteria) {
				return singleCreteria?.criteria?.rowIdentifier === 'OrderStatusID';
			});
		let updatedFiltes = [...search];
		dispatch(
			updateGrid({
				tableId,
				filters: {
					search: _.compact(updatedFiltes),
					pageNumber: 1,
					itemsPerPage: 50,
				},
				isStorageEnabled,
			})
		);
	}

	function* removeQuery({ payload }: any) {
		const { query, tableId } = payload;
		let searchQueries = yield select((state) => getQueries(state, tableId));
		searchQueries = _.filter(searchQueries, (q) => q.id !== query.id);
		let filters = getGridFilters(getState(), tableId);
		yield put(slice.updateSearchQueries({ searchQueries, tableId }));

		yield put(
			dynamicGridSlice.updateFilters({
				tableId,
				filters: { ...filters, search: searchQueries },
			})
		);

		yield put(
			dynamicGridSlice.updateMetadata({
				tableId,
				isAppend: true,
				metaData: {
					refreshTimestamp: Date.now(),
					isSoftRefresh: false,
				},
			})
		);
		// yield put(
		//   updateGrid({ tableId, filters: { ...filters, search: searchQueries } })
		// );
	}

	function* cleanupFilters({ payload }: any) {
		yield put(slice.updateSearchQueries({ searchQueries: null, tableId }));
	}

	function* updateQueries({ payload }: any) {
		const { selectedCriteria, searchInput, searchInputEnd, tableId, selectedOperator, remove } = payload;

		let searchQueries = yield select((state) => getQueries(state, tableId));
		const filters = getGridFilters(getState(), tableId);

		searchQueries = searchQueries || [];

		if (remove) {
			// 🗑 remove existing query by id or by criteria
			searchQueries = searchQueries.filter(
				(q) =>
					!_.isMatch(q.criteria, {
						rowIdentifier: selectedCriteria?.rowIdentifier,
					})
			);
		} else {
			// 🔍 find if query already exists with same criteria
			const existingQuery = _.find(searchQueries, (f) =>
				_.isMatch(f.criteria, {
					rowIdentifier: selectedCriteria?.rowIdentifier,
				})
			);

			if (existingQuery) {
				// replace the old query with a fresh one (new id + updated input)
				searchQueries = _.map(searchQueries, (q) => {
					if (
						_.isMatch(q.criteria, {
							rowIdentifier: selectedCriteria?.rowIdentifier,
						})
					) {
						return {
							id: existingQuery.id,
							criteria: selectedCriteria,
							query:
								selectedOperator &&
								(selectedOperator.value === 'btw' || selectedOperator.value === 'nbtw')
									? { from: searchInput, to: searchInputEnd }
									: searchInput,
							operator: selectedOperator,
						};
					}
					return q;
				});
			} else {
				// no existing → push new one
				searchQueries = [
					...searchQueries,
					{
						id: uuidv4(),
						criteria: selectedCriteria,
						query:
							selectedOperator && (selectedOperator.value === 'btw' || selectedOperator.value === 'nbtw')
								? { from: searchInput, to: searchInputEnd }
								: searchInput,
						operator: selectedOperator,
					},
				];
			}
		}

		yield put(slice.updateSearchQueries({ searchQueries, tableId }));

		yield put(
			dynamicGridSlice.updateFilters({
				tableId,
				filters: { ...filters, search: searchQueries },
			})
		);
		yield put(
			dynamicGridSlice.updateMetadata({
				tableId,
				isAppend: true,
				metaData: {
					refreshTimestamp: Date.now(),
					isSoftRefresh: false,
				},
			})
		);
		// yield put(
		//   updateGrid({ tableId, filters: { ...filters, search: searchQueries } })
		// );
	}

	async function updateAgQueries({ payload }) {
		const dispatch = getDispatch();
		const { searchQueries, tableId } = payload;
		let filters = getGridFilters(getState(), tableId);
		dispatch(slice.updateSearchQueries({ searchQueries, tableId }));
		dispatch(
			dynamicGridSlice.updateFilters({
				tableId,
				filters: { ...filters, search: searchQueries },
			})
		);
		dispatch(
			dynamicGridSlice.updateSelectedRows({
				tableId,
				selectedRowKeys: [],
				isSelectAll: false,
			})
		);
		dispatch(
			dynamicGridSlice.updateMetadata({
				tableId,
				isAppend: true,
				metaData: {
					refreshTimestamp: Date.now(),
					isSoftRefresh: false,
				},
			})
		);
	}
	return [
		yield takeLatest(sagaActions.createUpdateSearchQueries, createUpdateSearchQuery),
		yield takeLatest(sagaActions.removeQuery, removeQuery),
		yield takeLatest(sagaActions.updateAgQueries, updateAgQueries),
		yield takeLatest(sagaActions.updateQueries, updateQueries),
	];
}
